<ng-select
  [items]="currencyCodes"
  [addTag]="false"
  [hideSelected]="false"
  [searchFn]="searchCurrencyCodes"
  [readonly]="readonly"
  appendTo="body"
  [(ngModel)]="value"
  [trackByFn]="trackByFn"
  (ngModelChange)="onChangeFn($event)"
>
  <ng-template ng-label-tmp let-item="item" let-clear="clear">
    <span class="ng-value-label"> {{ item }}</span>
  </ng-template>
  <ng-template ng-option-tmp let-item="item"> {{ item }}</ng-template>
</ng-select>
